export default __webpack_public_path__ + "static/media/Group9200.3b694023.svg";